import { Action } from '@ngrx/store';
import { GenericError, User } from '@tendercuts/models';

export class ActionPopulateReduxUser implements Action {
  readonly type = 'ACTION_POPULATE_REDUX_USER';
  constructor(public payload: User) {}
}

export class ActionFetchUser implements Action {
  readonly type = 'ACTION_FETCH_USER';
  constructor(public payload) {}
}

export class ActionTryFail implements Action {
  readonly type = 'ACTION_FETCH_FAIL';
  constructor(public payload: GenericError) {}
}

export class ActionLoadUser implements Action {
  readonly type = 'ACTION_LOAD_USER';
  constructor(public payload) {}
}

export class ActionSaveUser implements Action {
  readonly type = 'ACTION_SAVE_USER';
  constructor(public payload: User) {}
}
